"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours
} = _uiKit.theme;
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "Itemstyle__Container",
  componentId: "sc-1sfd9y0-0"
})(["height:62px;padding:0 16px;border-top:1px solid ", ";border-bottom:1px solid ", ";display:flex;align-items:center;& > div{font-weight:600;color:", ";line-height:9.9px;letter-spacing:0.4px;font-size:9px;}&:first-child{border-top:none;}"], colours.NEUTRALS_4, colours.NEUTRALS_4, colours.NEUTRALS_4);